import React from 'react';
import { TransactionInfoContainer } from './TransactionInfo.styles';
import IntlMessages from '@iso/components/utility/intlMessages';

const getTime = date => {
  const dt = new Date(date);
  const hour = dt.getHours() < 10 ? `0${dt.getHours()}` : `${dt.getHours()}`;
  const min =
    dt.getMinutes() < 10 ? `0${dt.getMinutes()}` : `${dt.getMinutes()}`;
  return `${hour}:${min}`;
};
const TransactionInfo = ({ info }) => {
  return (
    <TransactionInfoContainer>
      <li>
        <p>
          <IntlMessages id="page.transaction_detail.transaction_info.date" />
          <b>
            {info.date ? new Date(info.date).toLocaleDateString('pt-BR') : '-'}
          </b>
        </p>
      </li>
      <li>
        <p>
          <IntlMessages id="page.transaction_detail.transaction_info.time" />
          <b>{info.date ? getTime(info.date) : '-'}</b>
        </p>
      </li>
      <li>
        <p>
          <IntlMessages id="page.transaction_detail.transaction_info.browser" />
          <b>{info.capture?.information?.browser ?? '-'}</b>
        </p>
      </li>
      <li>
        <p>
          <IntlMessages id="page.transaction_detail.transaction_info.os" />
          <b>{info.capture?.information?.os ?? '-'}</b>
        </p>
      </li>
      <li>
        <p>
          <IntlMessages id="page.transaction_detail.geolocation" />
          {info.capture?.information?.geolocation?.longitude !== "N/A" && info.capture?.information?.geolocation?.latitude !== "N/A" ? (
            <b>
              {info.capture?.information?.geolocation?.longitude}
              {', '}
              {info.capture?.information?.geolocation?.latitude}
            </b>
          ) : (<b>-</b>)}
        </p>
      </li>

      <li>
        <p>
          <IntlMessages id="page.transaction_detail.transaction_info.md5" />
          <b>{info.image?.md5 ?? '-'}</b>
        </p>
      </li>
      <li>
        <p>
          <IntlMessages id="page.transaction_detail.transaction_info.end_to_end" />
          <b>{info.end2end_id ?? '-'}</b>
        </p>
      </li>
      <li>
        <p>
          <IntlMessages id="page.transaction_detail.transaction_info.attempts" />
          <b>{info.capture?.information?.number_attempts ?? '-'}</b>
        </p>
      </li>
    </TransactionInfoContainer>
  );
};

export default TransactionInfo;
